<div class="h-full w-full si-card">

  <div class="border-b px-4 py-2 flex items-center justify-between">
    <h3 class="pt-2">Research on Demand</h3>
    <h6 class="mb-0 text-primary flex items-center" *ngIf="rodData?.length !== 0">
        <fa-icon class="mr-1 mat-primary si-icon"  [icon]="['fal', 'stopwatch']"></fa-icon> ~ {{totalMinutesSaved | minutesToMHD}} saved
    </h6>
  </div>

  <div class="pt-4 px-4">
    <p class="card-sub-header-text mb-1">
      {{ rodData?.length ? 'ROD Verified Contacts over the past 4 weeks' : '\u00A0' }}
    </p>

    <mat-radio-group
      aria-label="Select an option"
      class="text-center flex justify-center"
      [value]="selectedScope"
      (change)="onUserScopeChange($event.value)"
      *ngIf="!(selectedScope === 'all' && rodData?.length === 0 && !isLoading)">
      <mat-radio-button value="all" class="mx-2">All Users</mat-radio-button>
      <mat-radio-button value="current" class="mx-2">Current User</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="h-full flex flex-col px-4 pb-4 pt-1">

    <ng-container *ngIf="rodData !== undefined; else loading">
      <ng-container *ngIf="rodData.length === 0; else rodGraph">
        <div class="flex flex-col px-12 flex-wrap pt-6 h-full w-full items-center">
          <p class="text-center pb-2 text-secondary empty-state-text font-light">
            You have not sent any research requests in the past 4 weeks.
          </p>
          <p class="text-center pb-2 text-secondary empty-state-text font-light">
            Use Research on Demand to verify contacts you are interested in.
            <a href="https://support.salesintel.io/hc/en-us/articles/360020583474-Request-Research-on-Demand-ROD"
              target="_blank" class="text-primary">Learn more here.</a>
          </p>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #loading>
      <div class="flex justify-center items-center h-full w-full">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>

    <ng-template #rodGraph>
      <div class="mt-1 w-full h-full flex justify-center items-center">
        <div class="pt-1 w-full h-full flex justify-center items-center"
             *ngIf="isLoading; else chartContent">
          <mat-spinner></mat-spinner>
        </div>
        <ng-template #chartContent>
          <div class="w-full h-full">
            <app-bar-chart
              [chartLabels]="departmentList"
              [chartData]="chartData"
              [showDataLabel]="true"
              [showHorizontalGridLines]="true"
              [showTooltips]="false"
              [axisLabelFontSize]="11"
              [useAbbreviationYAxis]="true">
            </app-bar-chart>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>
</div>
